import type { Position } from "@/schemas/shared/position";
import { withFieldGroup } from "../form-context";
import { Field, FieldError, FieldLabel } from "@/client/components/shad/field";
import { Input } from "@/client/components/shad/input";

const defaultValues: Position = {
  longitude: 0,
  latitude: 0,
};

export const PositionFields = withFieldGroup({
  defaultValues,

  props: {},

  render: function Render({ group }) {
    return (
      <Field orientation="horizontal">
        <Field>
          <group.AppField name="longitude">
            {(field) => {
              const isInvalid =
                field.state.meta.isTouched && !field.state.meta.isValid;
              return (
                <Field>
                  <FieldLabel>Longitude</FieldLabel>
                  <Input
                    id={field.name}
                    name={field.name}
                    type="number"
                    value={field.state.value}
                    onChange={(e) => field.handleChange(e.target.valueAsNumber)}
                  />
                  {isInvalid && (
                    <FieldError
                      className="text-xs"
                      errors={field.state.meta.errors}
                    />
                  )}
                </Field>
              );
            }}
          </group.AppField>
        </Field>
        <Field>
          <group.AppField name="latitude">
            {(field) => {
              const isInvalid =
                field.state.meta.isTouched && !field.state.meta.isValid;
              return (
                <Field>
                  <FieldLabel>Latitude</FieldLabel>
                  <Input
                    id={field.name}
                    name={field.name}
                    type="number"
                    value={field.state.value}
                    onChange={(e) => field.handleChange(e.target.valueAsNumber)}
                  />
                  {isInvalid && (
                    <FieldError
                      className="text-xs"
                      errors={field.state.meta.errors}
                    />
                  )}
                </Field>
              );
            }}
          </group.AppField>
        </Field>
      </Field>
    );
  },
});
